import * as React from "react";
import { forwardRef } from "react";
const SvgGoFirstLastBaseIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 11.295L9.78082 9L12 6.705L11.3183 6L8.41741 9L11.3183 12L12 11.295ZM6 6H6.96696V12H6V6Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgGoFirstLastBaseIcon);
export { ForwardRef as ReactComponent };
